/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import { isStringEmpty, isArray, setTitle } from '../../../utils';
import { findQuestionByIdInSection, aoformQuestionShouldDisplay } from '../../../utils/AOFormUtils';
import { apiMap } from '../../../config/constants';
import * as basicInfoAction from '../state/action';
import * as appAction from '../../App/state/action'
//import * as businessInformationAction from '../../BusinessInformation/state/action';
import BasePage from '../../../shared/BasePage';
import BasicInfo from '../components/BasicInfo';
import * as updateStep from '../../CompanyRegistration/state/action';
//import paths from '../../../config/path';
import { isEmail,chineseCharacterAndMark } from '../../../utils/ValidationUtils';
/* eslint-disable array-callback-return */
class BasicInfoContainer extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            section:{},
            errorList:[],
            errorMsgs:{}
        }
    }

    loadContentMessage = () => {
        this.fetchData(this.props)
    }

    componentDidMount = () => {
        this.fetchData(this.props);
        this.switchLanguage(this.props);
    }

    componentWillReceiveProps = (nextProps) => {
        if(!this.state.section.id){
            this.fetchData(nextProps);
        }
         if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.switchLanguage(nextProps);
        }
    }

    switchLanguage = ({allCountryDatas, selectedLanguage}) => {
        this.setState({
            errorList:[],
            errorMsgs:{}
        });
        
        apiFetch(apiMap.basicInfo)().then( i18n => {
            allCountryDatas && this.props.saveCountryList(allCountryDatas, selectedLanguage);
            this.props.getBasicInfoMessage({ i18n });       
        }).catch( error => {});
    }

    fetchData = ({applicationInfo}) => {
        if(applicationInfo){
            let section = {};
            applicationInfo.sections.forEach((item) => {
                if(item.sectionId === "S001"){
                    section = JSON.parse(JSON.stringify(item));
                    //section = data;
                    this.initIndustryLevelData(section)
                    this.initMajorBusinessCountry(section)
                    this.setState({section:section})
                }        
            });          
        }
   }

   initMajorBusinessCountry = (section) => {
       let {businessInfo} = this.props
       let companyInfo = businessInfo.companyInfo
       if(companyInfo){
            let offShore = companyInfo.offShore
            let registerCountry = companyInfo.registerCountry
            let businessInfoQuestions = null
            if(!!section && !!section.questions && !!section.questions[1]){
                businessInfoQuestions = section.questions[1].subQuestions
            }
            let accountTypeQuestions = null
            if(!!section && !!section.questions && !!section.questions[3] && !!section.questions[3].subQuestions && !!section.questions[3].subQuestions[0]){
                accountTypeQuestions = section.questions[3].subQuestions[0].subQuestions
            }
            if(!offShore && registerCountry === "CN"){
                // if user has answered this question , followed by user's answer
                if(!!businessInfoQuestions && isArray(businessInfoQuestions)){
                    if(!businessInfoQuestions[0].userAnswer){       
                        // Default as "China" if the country of Registration is "China"      
                        businessInfoQuestions[0].userAnswer = { chosenAnswerId: 'A001-002-001:001' }
                    }
                    //entity type list depends on answer from SAIC page - Onshore: 1-8 Offshore: 9,10
                    businessInfoQuestions[1].answers.map((answer) => {
                        if(answer.index === 9 || answer.index === 10){ // WCB-8709 境外机构 and 境外其他企业
                            answer.hide = true
                        }else{
                            answer.hide = false
                        }
                    })
                }
                
                if(!!accountTypeQuestions && isArray(accountTypeQuestions)){
                    // handle accountType onshore/offshore logic
                    accountTypeQuestions.map((q)=>{
                        q.subQuestions[0].answers.map((answer)=>{
                            if(answer.index === 4){
                                answer.hide = true
                            }else{
                                answer.hide = false
                            }
                        })

                        //user click back button ,if offshore changed to onshore , related userAnswer should set null , accouttype should display normally
                        if(!!q.subQuestions[0].userAnswer){
                            let userAnswer = q.subQuestions[0].userAnswer.chosenAnswerId
                                if(!!userAnswer){
                                    if(userAnswer.split(":")[1] === "004"){
                                        q.subQuestions[0].userAnswer = null
                                        q.subQuestions[1].userAnswer = null
                                    }
                            }
                        }
 
                    })
                }
            }else{
                if(!!businessInfoQuestions && isArray(businessInfoQuestions)){
                    //entity type list depends on answer from SAIC page - Onshore: 1-8 Offshore: 9,10
                    businessInfoQuestions[1].answers.map((answer,index) => {
                        if(answer.index === 9 || answer.index === 10){ // WCB-8709 境外机构 and 境外其他企业
                            answer.hide = false
                        }else{
                            answer.hide = true
                        }
                    })
                }

                if(!!accountTypeQuestions && isArray(accountTypeQuestions)){
                    // handle accountType onshore/offshore logic
                    accountTypeQuestions.map((q)=>{
                        q.subQuestions[0].answers.map((answer)=>{
                            if(answer.index < 4){
                                answer.hide = true
                            }else{
                                answer.hide = false
                            }
                        })

                        //user click back button ,if onshore changed to offshore , related userAnswer should set null , accouttype should display normally
                        if(!!q.subQuestions[0].userAnswer){
                            let userAnswer = q.subQuestions[0].userAnswer.chosenAnswerId
                            if(!!userAnswer){
                                if(userAnswer.split(":")[1] === "003"){
                                    q.subQuestions[0].userAnswer = null
                                    q.subQuestions[1].userAnswer = null
                                }
                            }
                        }
                    })
                }
            }
       }
   }

   initIndustryLevelData = (section) => {
        let { industryLevelList } = this.props
        let group = section.questions[2].subQuestions
        let rootIndex = 0
        group.map((obj,index) => {
            const obj1Answer = obj.subQuestions[0] && obj.subQuestions[0].userAnswer
            obj.subQuestions.map((question,id)=>{
                if(id === 0){
                    //level one question always show
                    question.hide = false
                    // init level one question answers
                    question.answers = industryLevelList.roots
                    if(question.userAnswer){
                        let userAnswer = question.userAnswer.chosenAnswerId
                        rootIndex = userAnswer.split(":")[1]*1-1
                    }
                    let cascadingQId = this.caculateNextQuestionId(question.questionId)
                    let cascadingQuestion = findQuestionByIdInSection(section,cascadingQId)
                    if(!!cascadingQuestion){
                        cascadingQuestion.parentIndex = rootIndex
                    }
                }else if (id === 3){
                    //percentage field always show
                    question.hide = false
                }else if(id === 1 && question.userAnswer){
                    // questions that user have answered should show
                    question.hide = false
                    question.answers = industryLevelList.roots[rootIndex].children
                    let userAnswer = question.userAnswer.chosenAnswerId
                    let index1 = userAnswer.split(":")[1]*1-1
                    // if second level question is answered , let's check the third question's answer(if have)
                    let cascadingQId = this.caculateNextQuestionId(question.questionId)
                    let cascadingQuestion = findQuestionByIdInSection(section,cascadingQId)
                    if(cascadingQuestion){
                        if(cascadingQuestion.userAnswer){
                            cascadingQuestion.hide = false
                            cascadingQuestion.answers = industryLevelList.roots[rootIndex].children[index1].children
                        }else{
                            cascadingQuestion.hide = true
                        }
                    }
                }else if(id === 1 && obj1Answer){
                    // questions that user have answered should show
                    question.hide = false
                    question.answers = industryLevelList.roots[rootIndex].children
                } else {
                    if(question.userAnswer){
                        question.hide = false
                    }else{
                        question.hide = true
                    }               
                }
            })
        })
        this.setState({section:section})
   }

   valueDidChange = (questionRel, value) => {
        const {section,errorList} = this.state;
        const itemIndex = errorList.indexOf(questionRel.questionId);
        if (itemIndex !== -1) {
            errorList.splice(itemIndex, 1);
        }
        if(questionRel.questionIndicator === "companyNameE"){
            value = chineseCharacterAndMark(value)
        }
        switch (questionRel.answerType) {
            case 1: // Radio button
            case 5: // DropdownList
            case 27:
                questionRel.userAnswer = { chosenAnswerId: value };
                break;
            case 2: // Check box
                questionRel.userAnswer = { chosenAnswerId: value.join() }
                break;
            case 4: // Input
                questionRel.userAnswer = { contents: [value] }
                break;
            case 9: // Email
                questionRel.userAnswer = { contents: [value] }
                break;
            case 11: // CascadingDroupDownList
                questionRel.userAnswer = { chosenAnswerId: value };
                this.cascadingDropDownLogicHandlerNew(questionRel,value)
                break;
            case 16: // DateInput
                questionRel.userAnswer = { contents: [value] }
                break;
            default:
                break;
        }
        this.checkBranchVisitName(questionRel,value)
        this.setState({
            section:section,
            errorList:errorList
        })
    };

    onBlurAction = (questionRel, value) => {
        const {errorList} = this.state;
        const itemIndex = errorList.indexOf(questionRel.questionId);
        if (itemIndex !== -1) {
            errorList.splice(itemIndex, 1);
        }
        this.checkSingleQuestionAnswers(questionRel,errorList)
        this.setState({
            errorList:errorList
        })
    }
    
    checkBranchVisitName = (questionRel,value) => {
        if(questionRel.questionId === "Q001-004-002"){
            let question = this.state.section.questions[3].subQuestions[2]
            if(value === "A001-004-002:002"){              
                question.userAnswer = { chosenAnswerId: 'A001-004-003:001' }
                question.answers[1].hide = true
            }else{
                question.answers[1].hide = false
            }
        }
    }

    //industry level logic control
    cascadingDropDownLogicHandlerNew = (question, answer) => {
        const qId = question.questionId
        let {section} = this.state
        let {industryLevelList} = this.props
        const industryLevelArray = industryLevelList.roots
        const questionlevel = qId.substr(qId.length-1) 
        const answerIndex = answer.split(":")[1]*1-1
        if(questionlevel === "1"){           
            let cascadingQId = this.caculateNextQuestionId(qId)
            let cascadingQuestion = findQuestionByIdInSection(section,cascadingQId)
            let thirdQuestionId = this.caculateNextQuestionId(cascadingQId)
            let thirdLevelQuestion = findQuestionByIdInSection(section,thirdQuestionId)
            if(cascadingQuestion && answer){
                cascadingQuestion.hide = false;
                cascadingQuestion.userAnswer = null;
                const answers = industryLevelArray[answerIndex].children
                if(answers){
                    cascadingQuestion.answers = answers
                    cascadingQuestion.parentIndex = answerIndex
                }
            }else if(answer === ""){
                cascadingQuestion.hide = true;
                cascadingQuestion.userAnswer = null;
            }
            if(thirdLevelQuestion){
                thirdLevelQuestion.hide = true
                thirdLevelQuestion.userAnswer = null
            }        
        }else if(questionlevel === "2"){
            let cascadingQId = this.caculateNextQuestionId(qId)
            let cascadingQuestion = findQuestionByIdInSection(section,cascadingQId)
            if(cascadingQuestion && answer){
                const praretIndex = question.parentIndex
                const answers = industryLevelArray[praretIndex].children[answerIndex].children
                if(answers && isArray(answers) && answers.length > 0){
                    cascadingQuestion.answers = answers
                    cascadingQuestion.hide = false;
                    cascadingQuestion.userAnswer = null;
                }
            }else if(answer === ""){
                cascadingQuestion.hide = true;
                cascadingQuestion.userAnswer = null;
            }     
        }
        this.setState({section:section})
        
    }

    checkSubLevelAnswersByParentId = (question,parentId) => {
        question.answers.map((answer,index)=>{
            if(answer.parentId === parentId){
                answer.hide = false
            }else{
                answer.hide = true
            }
        })
    }
    
    // handle question4 : add account type 
    accountTypeAddAction = () => {
        let {section} = this.state
        let group = section.questions[3].subQuestions[0].subQuestions
        let addItem = JSON.parse(JSON.stringify(group[group.length-1]))
        let questionId = addItem.questionId
        let answerId = questionId.replace("Q","A")
        let condition = null;
        let newId = this.caculateNextQuestionId(questionId)
        let newAnswerId = this.caculateNextQuestionId(answerId)

        addItem.questionId = newId
        addItem.subQuestions.map((question,index)=>{
            question.questionId = question.questionId.replace(questionId,newId)
            question.userAnswer = null;
            if(question.condition){
                condition = JSON.parse(question.condition)
                if(condition.displayCondition && condition.displayCondition.conditions){
                    condition.displayCondition.conditions.map((item,index)=>{
                        item.questionId = item.questionId.replace(questionId,newId)
                        item.answer = item.answer.replace(answerId,newAnswerId)
                    })
                }
                question.condition = JSON.stringify(condition)
            }
            question.answers && question.answers.map((answer,i)=>{
                answer.answerId = answer.answerId.replace(answerId,newAnswerId)
            })
        })      
        group.push(addItem)
        this.setState({section:section})
    }

    industryLevelAddAction = () => {
        let {section} = this.state
        let group = section.questions[2].subQuestions
        let addItem = JSON.parse(JSON.stringify(group[group.length-1]))
        let questionId = addItem.questionId
        // let answerId = questionId.replace("Q","A")
        // let condition = null;
        let newId = this.caculateNextQuestionId(questionId)
        // let newAnswerId = this.caculateNextQuestionId(answerId)
        addItem.questionId = newId
        addItem.subQuestions.map((question,index)=>{           
            question.questionId = question.questionId.replace(questionId,newId)
            question.userAnswer = null;
            if(index === 0 || index === 3){
                //level one question and percentage field always show
                question.hide = false
            }else{
                question.hide = true
            }                              
        })      
        group.push(addItem)
        this.setState({section:section})
    }

    caculateNextQuestionId = (questionId) => {
        let newId = questionId.slice(questionId.lastIndexOf('-')+1)*1+1
        if(newId.toString().length === 2){
            newId = "0"+newId
        }else if(newId.toString().length === 1){
            newId = "00"+newId
        }
        return newId = questionId.substr(0,questionId.lastIndexOf('-')+1)+newId
    }

    accountTypeDelAction = (target,index)=> {
        let {section} = this.state
        let group = section.questions[3].subQuestions[0].subQuestions
        if(group.length !== 1){
            group.splice(index,1)
            this.setState({section:section})
        }else{
           return false
        }
    }

    industryLevelDelAction = (target,index)=> {
        let {section} = this.state
        let group = section.questions[2].subQuestions
        if(group.length !== 1){
            group.splice(index,1)
            this.setState({section:section})
        }else{
           return false
        }
    }

    validatePQForm = () => {
      //const { showLoaing } = this.props
      return new Promise((resolve, reject) => {
            //showLoaing(true)
            const { section, errorList } = this.state;
            let tempErrorList = errorList;
            tempErrorList.splice(0, tempErrorList.length)
            const questions = section.questions;
            this.validateSubQuestion(questions, tempErrorList);
            this.setState({
                errorList: tempErrorList
            }, () => {
                const { errorList } = this.state;
                if (errorList && errorList.length > 0) {
                    //showLoaing(false)
                    reject && reject(errorList)
                } else {
                    resolve && resolve()
                }
            });
        });
    }

    getInputContent = (userAnswer) => {
            return userAnswer && userAnswer.contents && userAnswer.contents.length > 0 && userAnswer.contents[0];
    }

    validateSubQuestion = (questions,errorList) => {  
        questions && questions.forEach((q)=> {
              this.checkUserAnswer(q,errorList)        
        })
    }

    checkUserAnswer = (question,errorList) => { 
        question.subQuestions.forEach((subq,index)=>{
            this.checkSingleQuestionAnswers(subq,errorList)
        })
    }

    checkSingleQuestionAnswers = (question,errorList) => {
        const {errorMsgs, section} = this.state;
        const { applicationInfo, i18n, appMessages } = this.props;
        let requireErrorMsg = i18n.error_msg;
        const removeFormErrorList = (errorList, index) => {
            if (index !== -1) {
                errorList.splice(index, 1);
            }
        }
        const addError = (errorList, index, errorItem) => {
            if (index === -1) {
                errorList.push(errorItem);
            }
        }  
        const {
            questionId,
            userAnswer,
            answerType,
            subQuestions,
            condition,
            hide
        } = question;
        let tempUserAnswer = null;
        //const app = replaceQuestion(applicationInfo, subq);
        //replaceQuestion has defect, will check at 2018-1-25
        const app = JSON.parse(JSON.stringify(applicationInfo))
        app.sections[0] = section
        const shouldDisplay = aoformQuestionShouldDisplay(app, question); 
        if (!shouldDisplay) {
            const itemIndex = errorList.indexOf(questionId);
            removeFormErrorList(errorList, itemIndex);
            return;
        }
        if(subQuestions && isArray(subQuestions) && subQuestions.length > 0 ){
            this.checkUserAnswer(question,errorList)
        }else{
            let mandatory = false;
            if (condition) {
                const conditionObj = JSON.parse(condition);
                mandatory = conditionObj.mandatory
            }
            const itemIndex = errorList.indexOf(questionId);

            switch (answerType) {
                case 5: // Drop down list
                case 27:
                    tempUserAnswer = userAnswer && userAnswer.chosenAnswerId
                    requireErrorMsg = i18n.error_msg_select;
                    break;
                case 4: // Input Field
                    tempUserAnswer = userAnswer && this.getInputContent(userAnswer)
                    requireErrorMsg = i18n.error_msg
                    break;
                case 9: // email
                    tempUserAnswer = userAnswer && this.getInputContent(userAnswer)
                    requireErrorMsg = i18n.error_msg
                    if(!isStringEmpty(tempUserAnswer) && !isEmail(tempUserAnswer)){
                        requireErrorMsg = appMessages.form_base_content.invalid_email
                        addError(errorList, itemIndex, questionId);
                        errorMsgs[questionId] = requireErrorMsg
                    }
                    break;
                case 11: // Cascading Drop down list
                    tempUserAnswer = userAnswer && userAnswer.chosenAnswerId
                    requireErrorMsg = i18n.error_msg_select;
                    break;
                default:
                    break;          
            }

            if (isStringEmpty(tempUserAnswer) && mandatory && !hide) {
                addError(errorList, itemIndex, questionId);
                errorMsgs[questionId] = requireErrorMsg
            }else{
                requireErrorMsg = this.checkIndustryLevelData(question,tempUserAnswer)
                if(requireErrorMsg){
                    addError(errorList, itemIndex, questionId);
                    errorMsgs[questionId] = requireErrorMsg
                }else{
                    removeFormErrorList(errorList, itemIndex);
                }                  
            }
        }
        
    }

    caculateIndicator = (question,answer) => {
        const index = answer.split(":")[1]*1-1
        const indicator = question.answers[index].indicator
        return indicator     
    }

    checkIndustryLevelData = (question,answer) => {
        const questionId = question.questionId
        if(questionId.indexOf("Q001-003") !== -1 ){
            let levelflag = questionId.substr(questionId.length-1)*1
            const { section } = this.state;
            const { i18n } = this.props;
            let group = section.questions[2].subQuestions
            if(levelflag === 4){
                let percentageCheck = 0
                group.map((obj)=>{
                    obj.subQuestions.map((item,index)=>{
                        if(index === 3 ){
                            const userAnswer = item.userAnswer
                            percentageCheck = this.getInputContent(userAnswer)*1+percentageCheck
                        }
                    })
                })
                if(percentageCheck > 100){
                    return i18n.error_msg_percentage
                }
            }else if(levelflag === 3){
                let duplicateFlag = false;
                group.map((obj)=>{
                    obj.subQuestions.map((item,index)=>{
                        if(index === 2 ){
                            let userAnswer = item.userAnswer
                            if(userAnswer && userAnswer.chosenAnswerId && answer){
                                let answer1 = this.caculateIndicator(item,userAnswer.chosenAnswerId)
                                let answer2 = this.caculateIndicator(question,answer)
                                if(answer1 === answer2 && questionId !== item.questionId){
                                    duplicateFlag = true
                                }
                            }                           
                        }
                    })                  
                })
                if(duplicateFlag){
                    return i18n.error_msg_duplicate
                }
            }
        }
    }
    
    render() {
        const { i18n, applicationInfo, pageTitle} = this.props
        const {section,errorList,errorMsgs} = this.state
        if (i18n && pageTitle) {
          setTitle( i18n.title + pageTitle);
        }

        return (i18n && applicationInfo && section)? (
            <div>
                <BasicInfo 
                    { ...this.props }
                    section = {section}
                    errorList = {errorList}
                    errorMsgs = {errorMsgs}
                    valueDidChange = {this.valueDidChange}
                    onBlurAction = {this.onBlurAction}
                    accountTypeAddAction = {this.accountTypeAddAction}
                    accountTypeDelAction = {this.accountTypeDelAction}
                    industryLevelAddAction = {this.industryLevelAddAction}
                    industryLevelDelAction = {this.industryLevelDelAction}
                    validatePQForm = {this.validatePQForm}
                />
            </div>
        ) : null
    }
}

BasicInfoContainer.propTypes = {
    i18n: PropTypes.object,
    selectedLanguage: PropTypes.string,
    applicationInfo:PropTypes.object,
    appMessages:PropTypes.object,
    countryListDatas:PropTypes.array,
    industryLevelList:PropTypes.object,
    businessInfo:PropTypes.object
};

const mapStateToProps = (state) => ({
    i18n:state.basicInfo.i18n,
    selectedLanguage: state.app.selectedLanguage,
    applicationInfo: state.app.applicationInfo,
    appMessages:state.app.i18n,
    countryListDatas:state.app.countryListDatas,
    allCountryDatas: state.app.allCountryDatas,
    industryLevelList:state.app.industryLevelList,
    businessInfo:state.app.businessInfo,
    pageTitle: state.app.i18n.pageTitle
});

const mapDispatchToProps = (dispatch) => {
    //return bindActionCreators(basicInfoAction, dispatch);
    return {
        ...bindActionCreators(basicInfoAction, dispatch),
        ...bindActionCreators(appAction, dispatch),
        ...bindActionCreators(updateStep, dispatch)
    }/* ...bindActionCreators(businessInformationAction, dispatch),*/
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BasicInfoContainer);


// WEBPACK FOOTER //
// ./src/views/BasicInfo/container/BasicInfo.js